export default __webpack_public_path__ + "svg/calendar/2027/5/mayo.svg?23e8527f";